module.exports = __webpack_public_path__ + "img/ico_print.c31aa06a.svg";